<template>
    <div class="main">
        <div class="body-content">
            <h3>Missing SB Report List</h3>
            <div class="form-group">
                <div class="form-item">
                    <label for="partyname">Party *</label>
                    <v-select :clearable="false" tabindex="0" placeholder="Select Party Name" id="partyname"
                        v-model="newContainer.partyName" :options="party" label="short_name"
                        :reduce="party => party.autoid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="fromdate">From Date(YYYYMM) </label>
                    <input type="text" id="fromdate" v-model="newContainer.fromdate" placeholder="YYYYMM" />
                </div>
                <div class="form-item">
                    <label for="todate">To Date(YYYYMM) </label>
                    <input type="text" id="todate" v-model="newContainer.todate" placeholder="YYYYMM" />
                </div>
                <div class="form-item">
                    <button type="button" class="excel-button" @click="generate_report"
                        :disabled="isSubmitting">Generate
                        Report</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import axios from 'axios';
import { useToast } from 'vue-toastification';
import * as cs from '../assets/js/commonscript.js'
export default {
    components: {
        VSelect,
    },
    data() {
        return {
            transactions: [],
            party: JSON.parse(localStorage.getItem('party')),
            accounts: JSON.parse(localStorage.getItem('accounts')) || [],
            applicants: JSON.parse(localStorage.getItem('applicants')) || [],
            isSubmitting: false,
            newContainer: {
                applicantID: 0,
                accountID: 0,
                fromdate: '',
                todate: '',
            },
        };
    },
    methods: {
        getNameById(array, id, key = 'id', nameKey = 'name') {
            const item = array.find(item => item[key] === id);
            return item ? item[nameKey] : '';
        },
        updateApplicantAccountIds(value) {
            const AppAcc = cs.GetAppAccFromParty(value)
            this.newContainer.applicantID = AppAcc.applicantid
            this.newContainer.accountID = AppAcc.accountid
        },
        async generate_report() {
            if (this.isSubmitting) return;

            const { partyName, fromdate, todate } = this.newContainer;
            if (!partyName || !fromdate || !todate) {
                useToast().error('Please fill in all required fields.');
                return;
            }
            this.isSubmitting = true;
            try {
                this.updateApplicantAccountIds(this.newContainer.partyName)
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`, // Include the token in the headers
                    },
                };
                const applicantname = this.getNameById(this.applicants, this.newContainer.applicantID, 'applicantid', 'applicantname');
                const accountname = this.getNameById(this.accounts, this.newContainer.accountID, 'accountid', 'accountname');
                //console.log(`Generating report for Applicant: ${applicantname}, Account: ${accountname}, From: ${fromdate}, To: ${todate}`);
                const response = await axios.get(`/GenerateContainerDischargeLoadingReport?applicant=${this.newContainer.applicantID}&account=${this.newContainer.accountID}&fromdate=${fromdate}&todate=${todate}&applicantname=${applicantname}&accountname=${accountname}`, config);
                //console.log(response.data);
                if (response.data[0] == 0) {
                    useToast().error(response.data[1]);
                } else if (response.data[0] == 2) {
                    useToast().success(response.data[1]);
                } else {
                    useToast().success('Mail Sending SUccessfully');
                    //console.log(response);
                }
            } catch (error) {
                console.log(error);
                useToast().error('An error occurred while generating the report');
            } finally {
                this.isSubmitting = false;
            }
        },

    },
};
</script>

<style scoped>
/* Form group styling for form elements */
.form-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 5px;
}

.form-item {
    width: 22%;
}

select,
input[type="text"],
input[type="date"],
input[type="number"],
v-select {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: #FFF;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}
</style>
